import {httpRequest} from "./http-request";

export const billingServices = {
    getTariffList,
    getTariff,
    subscribe,
    checkSubscription,
    getSubscriptionByLegalEntity,
    getSubscriptionHistory,
    getCurrentSubscription,
    getDeposit,
    getDepositHistory,
    getInvoices,
    getPaidInvoices,
    getLegalEntitiesByPartner,
    updateSubscription,
    createInvoice,
    markInvoicePaid,
    cancelInvoice,
};

async function getTariffList() {
    return httpRequest.get('billing/get-tariff-list');
}

async function getTariff(id) {
    return httpRequest.get(`billing/get-tariff?id=${id}`);
}

async function subscribe(tariffId, legalEntityId, data = {}) {
    return httpRequest.post('billing/subscribe', {
        tariffId,
        legalEntityId,
        type: data.type || 'regular',
        dateStart: data.dateStart || null,
        dateEnd: data.dateEnd || null,
        customPrice: data.customPrice !== undefined ? data.customPrice : null,
    });
}

async function checkSubscription() {
    return httpRequest.get('billing/check-subscription');
}

async function getSubscriptionByLegalEntity(legalEntityId) {
    return httpRequest.get(`billing/get-subscription-by-legal-entity?legalEntityId=${legalEntityId}`);
}

async function getSubscriptionHistory(subscriptionId) {
    return httpRequest.get(`billing/get-subscription-history?subscriptionId=${subscriptionId}`);
}

async function getCurrentSubscription() {
    return httpRequest.get('billing/get-current-subscription');
}

async function getDeposit(legalEntityId) {
    return httpRequest.get(`billing/get-deposit?legalEntityId=${legalEntityId}`);
}

async function getDepositHistory(depositId) {
    return httpRequest.get(`billing/get-deposit-history?depositId=${depositId}`);
}

async function getInvoices(legalEntityId) {
    return httpRequest.get(`billing/get-invoices?legalEntityId=${legalEntityId}`);
}

async function getPaidInvoices(legalEntityId) {
    return httpRequest.get(`billing/get-paid-invoices?legalEntityId=${legalEntityId}`);
}

async function getLegalEntitiesByPartner(partnerId) {
    return httpRequest.get(`billing/get-legal-entities-by-partner?partnerId=${partnerId}`);
}

async function updateSubscription(subscriptionId, data) {
    return httpRequest.post('billing/update-subscription', {
        subscriptionId,
        ...data,
    });
}

async function createInvoice(subscriptionId) {
    return httpRequest.post('billing/create-invoice', {
        subscriptionId,
    });
}

async function markInvoicePaid(invoiceId) {
    return httpRequest.post('billing/mark-invoice-paid', {
        invoiceId,
    });
}

async function cancelInvoice(invoiceId) {
    return httpRequest.post('billing/cancel-invoice', {
        invoiceId,
    });
}
